import httpClient from '../utils/HttpClient';
import { EVENTS_URL } from '../constants/Url';
import { objectToQuery } from '../utils/Utils';

export const fetchMyEvents = async (params = {}) => {
  const query = {
    tab: params.tab || 'ongoing',
    keyword: params.keyword || '',
    pageNo: params.pageNo || 1,
    pageSize: params.pageSize || 10,
    startDate: params.startDate || '',
    endDate: params.endDate || ''
  };

  const url = objectToQuery(EVENTS_URL, query);
  const response = await httpClient.get(url);
  return response.data;
};

export const fetchEventDetail = async (id) => {
  const url = `${EVENTS_URL}/${id}`;
  const response = await httpClient.get(url);
  return response.data;
};

export const registerEvent = async (payload) => {
  const response = await httpClient.post(EVENTS_URL, payload);
  return response.data;
};

export const recordEventScan = async (payload) => {
  try {
    const response = await httpClient.post(`${EVENTS_URL}/scanned`, payload);
    return response.data;
  } catch (err) {
    return null;
  }
};

